import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  IKeyValue,
  removeCookies,
  setBrowserData,
  setCookie,
  setCookies,
  setDeviceId,
} from '../actions';
import { IBrowserInfo } from '../reducers';

@Injectable()
export class BrowserManagerDispatcher {
  constructor(private _store: Store<any>) {}

  setCookie(key: string, value: string) {
    this._store.dispatch(setCookie(key, value));
  }

  setCookies(cookies: IKeyValue[]) {
    this._store.dispatch(setCookies(cookies));
  }

  removeCookies(keys: string[], path?: string, domain?: string) {
    this._store.dispatch(removeCookies(keys, path, domain));
  }

  setBrowserData(browserInfo: IBrowserInfo) {
    this._store.dispatch(setBrowserData(browserInfo));
  }

  setDeviceId(deviceId: string) {
    this._store.dispatch(setDeviceId(deviceId));
  }
}
